import { useOutletContext } from "react-router-dom";
import SearchAssistant from "@/components/search/SearchAssistant";

export default function Home() {
  const [closeSidebar] = useOutletContext<any>();
  return <SearchAssistant closeSidebar={closeSidebar} />;
}
